import { useState } from "react";
import { Share2, Check, Copy } from "lucide-react";
import { toast } from "sonner";

/**
 * ShareButton — Web Share API with copy-to-clipboard fallback.
 * Props: title, text, url (URL to share — should be a server-rendered OG endpoint for bot previews)
 */
export default function ShareButton({ title, text, url, variant = "pill", size = "md", label = "Compartir", testId = "share-btn" }) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const shareData = { title: title || "cadii", text: text || "", url: url || window.location.href };

    if (navigator.share && typeof navigator.share === "function") {
      try {
        await navigator.share(shareData);
        return;
      } catch (err) {
        // User cancelled or share failed — fall through to copy
        if (err?.name === "AbortError") return;
      }
    }

    // Fallback: copy URL to clipboard
    try {
      await navigator.clipboard.writeText(shareData.url);
      setCopied(true);
      toast.success("Enlace copiado al portapapeles");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("No se pudo copiar el enlace");
    }
  };

  const sizeCls = size === "sm" ? "text-xs px-3 py-1.5 gap-1.5" : "text-sm px-4 py-2 gap-2";
  const iconSz = size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";

  const styles = {
    solid: "bg-[#1B4D3E] hover:bg-[#163F33] text-white shadow-sm",
    ghost: "bg-transparent hover:bg-white/10 text-white border border-white/30",
    pill: "bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm border border-white/20",
    light: "bg-white hover:bg-gray-50 text-[#1B4D3E] border border-gray-200 shadow-sm",
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      className={`inline-flex items-center justify-center rounded-full font-medium transition-all ${sizeCls} ${styles[variant] || styles.pill}`}
      data-testid={testId}
      aria-label={label}
    >
      {copied ? <Check className={iconSz} /> : navigator.share ? <Share2 className={iconSz} /> : <Copy className={iconSz} />}
      <span>{copied ? "Copiado" : label}</span>
    </button>
  );
}
